import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Table, Tr, Td, Thead, Th } from 'reactable';
import { connect } from 'react-redux';
import { FormControl } from 'react-bootstrap';
import { graphql, gql, compose } from 'react-apollo';

// Style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ManagePayout.css';

import CurrencyConverter from '../../CurrencyConverter';
import Link from '../../Link';

import CustomPagination from '../../CustomPagination';

//graphql
import reservationsQuery from './reservationsQuery.graphql';
import { updatePayoutStatus } from '../../../actions/updatePayoutStatus';
import { getPayoutStatus } from './getPayoutStatus';

class ManagePayout extends React.Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        getAllPayouts: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
            refetch: PropTypes.any.isRequired,
            getTransactionHistory: PropTypes.shape({
                count: PropTypes.number.isRequired,
                reservationData: PropTypes.arrayOf(PropTypes.shape({
                    id: PropTypes.number.isRequired,
                    listId: PropTypes.number.isRequired,
                    hostId: PropTypes.string.isRequired,
                    guestId: PropTypes.string.isRequired,
                    checkIn: PropTypes.string.isRequired,
                    checkOut: PropTypes.string.isRequired,
                    guestServiceFee: PropTypes.number.isRequired,
                    hostServiceFee: PropTypes.number.isRequired,
                    total: PropTypes.number.isRequired,
                    currency: PropTypes.string.isRequired,
                    reservationState: PropTypes.string.isRequired,
                    listData: PropTypes.shape({
                        title: PropTypes.string.isRequired
                    }),
                    hostData: PropTypes.shape({
                        profileId: PropTypes.number.isRequired,
                        firstName: PropTypes.string.isRequired
                    }),
                    hostPayout: PropTypes.shape({
                        id: PropTypes.number.isRequired,
                        payEmail: PropTypes.string.isRequired,
                        methodId: PropTypes.number.isRequired,
                        currency: PropTypes.string.isRequired,
                        last4Digits: PropTypes.number
                    }),
                    hostTransaction: PropTypes.shape({
                        id: PropTypes.number.isRequired,
                    }),
                    hostFailedTransaction: PropTypes.shape({
                        id: PropTypes.number.isRequired,
                    }),
                    guestData: PropTypes.shape({
                        profileId: PropTypes.number.isRequired,
                        firstName: PropTypes.string.isRequired
                    }),
                    transaction: PropTypes.shape({
                        payerEmail: PropTypes.string.isRequired,
                        paymentType: PropTypes.string.isRequired,
                        total: PropTypes.number.isRequired,
                        currency: PropTypes.string.isRequired,
                        paymentMethodId: PropTypes.number
                    }),
                    refundStatus: PropTypes.shape({
                        id: PropTypes.number.isRequired,
                        receiverEmail: PropTypes.string.isRequired,
                        total: PropTypes.number.isRequired,
                        currency: PropTypes.string.isRequired
                    }),
                    cancellationDetails: PropTypes.shape({
                        refundToGuest: PropTypes.number.isRequired,
                        refundFee: PropTypes.number.isRequired,
                        payoutToHost: PropTypes.number.isRequired,
                        total: PropTypes.number.isRequired,
                        currency: PropTypes.string.isRequired,
                        guestServiceFee: PropTypes.number.isRequired,
                        hostServiceFee: PropTypes.number.isRequired,
                    }),
                })),
            }),
        }).isRequired,
    }

    static defaultProps = {
        getAllPayouts: {
            loading: true,
            getAllPayoutReservation: {
                count: null,
                reservationData: []
            }
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            searchList: '',
            typing: false,
            typingTimeout: 0
        }
        this.paginationData = this.paginationData.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleHoldPayout = this.handleHoldPayout.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { getAllPayouts: { completed, loading } } = nextProps;
        const { searchList, currentPage } = this.state;
        const { getAllPayouts: { refetch } } = this.props;
        let variables = { currentPage, searchList };
        if (completed && !loading) {
            refetch(variables);
        }
    }

    paginationData(currentPage) {
        const { getAllPayouts: { refetch } } = this.props;
        let variables = { currentPage };
        this.setState({ currentPage });
        refetch(variables);
    }

    handleClick(searchList) {
        const { getAllPayouts: { refetch } } = this.props;
        const { currentPage } = this.state;
        let variables = {
            currentPage: 1,
            searchList: searchList
        };
        this.setState({ currentPage: 1 });
        refetch(variables);
    }

    handleSearchChange = (e) => {
        const self = this;
        if (self.state.typingTimeout) {
            clearTimeout(self.state.typingTimeout);
        }
        self.setState({
            searchList: e.target.value,
            typing: false,
            typingTimeout: setTimeout(function () {
                self.handleClick(self.state.searchList);
            }, 450)
        });
    }

    handleHoldPayout(e, id, currentPage) {
        const { updatePayoutStatus, getAllPayouts: { refetch } } = this.props;
        let isHold = e.target.value;
        isHold = isHold == "true" ? true : false;
        updatePayoutStatus(id, isHold);
        let variables = { currentPage };
        this.setState({ currentPage });
        refetch(variables);
    }

    render() {
        const { title, } = this.props;
        const { getAllPayouts: { loading, getAllPayoutReservation, refetch }} = this.props;
        const { currentPage } = this.state;
        
       return (
            <div className={cx(s.pagecontentWrapper)}>
                <div className={s.contentBox}>
                    <h1 className={s.headerTitle}>{title}</h1>
                    <div className={'table-responsive'}>
                        <div className={cx('col-md-4', s.seachContent)} >
                            <FormControl
                                type="text"
                                placeholder={'Search'}
                                onChange={(e) => this.handleSearchChange(e)}
                            />
                        </div>
                        <Table
                            className="table"
                            noDataText="No matching records found."
                            sortable={true}
                        >
                            <Thead>
                               
                                <Th column={"Reservation ID"}>Reservation ID</Th>
                                <Th column={"Code"}>Code</Th>
                                <Th column={"List Title"}>List Title</Th>
                                <Th column={"Host Name"}>Host Name</Th>
                                <Th column={"Payout Amount"}>Payout Amount</Th>
                                <Th column={"Reservation Status"}>Reservation Status</Th>
                                <Th column={"Payout Status"}>Payout Status</Th>
                                <Th column={"Hold Payout"}>Hold Payout</Th>
                                <Th column={"Details"}>Details</Th>
                               
                            </Thead>
                            {
                                getAllPayoutReservation && getAllPayoutReservation.reservationData && getAllPayoutReservation.reservationData.length > 0 && getAllPayoutReservation.reservationData.map((item, index) => {
                                    let payoutAmount;
                                    let status = getPayoutStatus(item);
                                    
                                    if(item.reservationState == 'cancelled') {
                                        payoutAmount = item.cancellationDetails.payoutToHost;
                                    } else {
                                        payoutAmount = item.total - item.hostServiceFee;
                                    }
                                    return (
                                        <Tr key={index}>
                                            <Td column={"Reservation ID"} data={item.id} />
                                            <Td column={"Code"}>
                                                {item.confirmationCode}
                                            </Td>
                                            {
                                                item.listData && <Td column={"List Title"}>
                                                    <a href={"/spaces/" + item.listId} target='_blank'>
                                                        {item.listData.title}
                                                    </a>
                                                </Td>
                                            }
                                            {
                                                !item.listData && <Td column={"List Title"} data={"List is missing"} />
                                            }
                                            <Td column={"Host Name"}>
                                                {item.hostData && item.hostData.firstName}
                                            </Td>
                                            <Td column={"Payout Amount"}>
                                                <CurrencyConverter
                                                    amount={payoutAmount}
                                                    from={item.currency}
                                                />
                                            </Td>
                                            <Td column={"Reservation Status"} data={item.reservationState.toUpperCase()} />
                                            <Td column={"Payout Status"}>
                                                {
                                                    status === 'Failed' ? <Link to={'/siteadmin/failed-payout/'+ item.id}>{status}</Link> : status
                                                }
                                            </Td>
                                            <Td column={"Hold Payout"}>
                                                <select value={item.isHold} onChange={(e) => this.handleHoldPayout(e, item.id, currentPage)}>
                                                    <option value={true}>Yes</option>
                                                    <option value={false}>No</option>
                                                </select>
                                            </Td>
                                            <Td column={"Details"}>
                                                <Link to={"/siteadmin/viewreservation/" + item.id + '/payout'} >
                                                    View
                                                </Link>
                                            </Td>
                                        </Tr>
                                    )
                                })
                            }
                        </Table>
                        {
                            getAllPayoutReservation && getAllPayoutReservation.reservationData && getAllPayoutReservation.reservationData.length > 0 &&
                            <CustomPagination
                                total={getAllPayoutReservation.count}
                                currentPage={currentPage}
                                defaultCurrent={1}
                                defaultPageSize={10}
                                change={this.paginationData}
                                paginationLabel={'Payouts'}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const mapState = (state) => ({
    completed: state.payout.completed,
    loading: state.payout.loading,
});

const mapDispatch = {
    updatePayoutStatus,
};
export default compose(
    withStyles(s),
    connect(mapState, mapDispatch),
    graphql(reservationsQuery, {
        name: 'getAllPayouts',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
        }
    })
)(ManagePayout);